/**
 * @title addressBook.js: Feature level module
 * @description Module associated with address book section
 */
define([], function() {
  let CAddressBook = {
    url: {
      MANAGE_ADDRESS_UPDATE: '/AjaxManageAddressCmd?mode=UPDATE',
      MANAGE_ADDRESS_ADD: '/AjaxManageAddressCmd?mode=ADD',
      MANAGE_ADDRESS_SET_DEFAULT: '/AjaxManageAddressCmd?mode=SET_DEFAULT',
      MANAGE_ADDRESS_REMOVE: '/AjaxManageAddressCmd?mode=DELETE',
      MANAGE_ADDRESSTYPE_UPDATE: '/AjaxManageAddressCmd?mode=SET_ADDRESSTYPE',
    },

    /**
     * Constants
     */
    DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT: 114,

    DEFAULT_ADDRESS_CELL_HEIGHT: 140,

    DEFAULT_ADDRESS_CELL_TITLE_HEIGHT: 24,

    ENTRIES_PER_PAGE_LG: 8,
    ENTRIES_PER_PAGE_NON_LG: 7,

//    ADDRESS_TYPE_SHIPPING: 'Shipping',
//    ADDRESS_TYPE_BILLING: 'Billing',
    
    ADDRESS_TYPE_SHIPPING: 'S',
    ADDRESS_TYPE_BILLING: 'B',
    
    ADDRESS_TYPE_S : 'S',
    ADDRESS_TYPE_B : 'B',
    
    ADDRESS_SORT_MOST_RECENT: '1',
    ADDRESS_SORT_FIRST_A_Z: '2',
    ADDRESS_SORT_FIRST_Z_A: '3',
    ADDRESS_SORT_LAST_A_Z: '4',
    ADDRESS_SORT_LAST_Z_A: '5',
    ADDRESS_SORT_COMPANY_NAME_A_Z: '6',
    ADDRESS_SORT_COMPANY_NAME_Z_A: '7',
    
    currentShippingPage: 1,
    currentBillingPage: 1,
    resizeTimer: 0,
    activeTab: 'S',

    /**
     * Adjust add button height to be equal to address cells.
     */
    adjustAddButtonHeight: function() {
      let currentBtnHeight = $('.add-new-address > .caption').height();
      let topPadding = (CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - currentBtnHeight) / 2;
      if ($('#xs-sm-visible-indicator').css('display') === 'none') {
        // Btn height should be same as address cell next to it, otherwise it should be square.
        let addressCellHeight = ($('.address-cell').length > 0) ?
          $('.address-cell:first').height() - 2.75 :
          $('.add-new-address').width(); // -1 for fine cells alignment
        if (addressCellHeight != null && addressCellHeight > CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT) {
          topPadding = (addressCellHeight - currentBtnHeight) / 2;
          $('.add-new-address').height(addressCellHeight - 1);
        }
      } else {
    	// Subtracting 2.5 from desired height because of border-box box-sizing 
        $('.add-new-address').height(CAddressBook.DEFAULT_ADDRESS_ADD_BUTTON_HEIGHT - 2.5);
      }
      $('.add-new-address > .caption').css('margin-top', topPadding + 'px');
    },

    /**
     * Adjust cell title section height when label breaks to two lines
     */
    adjustAddressCellTitleSection() {
      let aHrefHeight = ($('.address-cell > .style-check > a').length > 0) ?
        $('.address-cell > .style-check > a:last').height() :
        0;
      let pHeight = ($('.address-cell > .style-check > p').length > 0) ?
        $('.address-cell > .style-check > p:last').height() :
        0;
      let higher = (aHrefHeight > pHeight) ? aHrefHeight : pHeight;
      let cellHeight = $('.address-cell > .style-check').height();
      if (cellHeight < CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT) {
        cellHeight = CAddressBook.DEFAULT_ADDRESS_CELL_TITLE_HEIGHT;
      }
      let finalHeight = (higher > cellHeight) ? higher : cellHeight;
      finalHeight = finalHeight + parseInt($('.address-cell > .style-check').css('padding-top')) + parseInt($('.address-cell > .style-check').css('padding-bottom'));
      $('.address-cell > .style-check').map(function() {
        $(this).innerHeight(finalHeight);
      });
    },

    /**
     * Adjust cell matrix element's size
     * @param alignClass - class of elements which will be processed
     */
    addjustCells: function(alignClass) {
      if (this.getColumnNumber() > 1) {
        // 4 rows maximum
        COSTCO.util.adjustDivHeights(alignClass + '-0', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
        COSTCO.util.adjustDivHeights(alignClass + '-1', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
        COSTCO.util.adjustDivHeights(alignClass + '-2', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT);
        COSTCO.util.adjustDivHeights(alignClass + '-3', CAddressBook.DEFAULT_ADDRESS_CELL_HEIGHT); ;
      }
      this.adjustAddressCellTitleSection();
      this.adjustAddButtonHeight();
    },

    init: function() {
      // Case where user is timed out from address page and clicks back in browser tab without logging in. This reloads the page so that the user relands on the logon page rather than the auth address page.
		  if (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward' && !$.cookie('hashedUserId')) {
		  	window.location.reload(true)
		  }

      // this.currentPage = 1;
      this.setActiveAddressType();
      this.bindEvents();
      if (COSTCO.util.isBusinessDelivery()){
          COSTCO.CAddressForm.initiatePopovers();
      }

      if(document.readyState == 'complete'){
    	  this.initializeAddresses();
      }else{
    	  $(window).on('load', function() {
    		  COSTCO.CAddressBook.initializeAddresses();  
    	  })
      }
      COSTCO.CAddressBook.addressbookTabAriaExpandedSwitch();
      COSTCO.CAddressBook.analytics();
    },

    initializeAddresses: function(addressType) {
    	COSTCO.util.resetAddressLoadState();
    	COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_SHIPPING, 'ALL', 'RECENT', '1', '100000', function(data) {
    	COSTCO.CAddressBook.validateShippingAddressPhoneNumber(data.addresses);	
        COSTCO.util.getAddressBatch(COSTCO.CAddressBook.ADDRESS_TYPE_BILLING, 'ALL', 'RECENT', '1', '100000', function(data) { 
    			COSTCO.CAddressBook.populate(data);
    		});
    	});
    },
    
    populate: function(data) {
    	
        COSTCO.CAddressBook.createNewAddressButton('add-new-address-btn-box');
        COSTCO.CAddressBook.populateAddressSection('addresses-list-box', 1);
    },
    
    /**
     * Events binding for address section elements
     */
    bindEvents: function() {
      $('#billingTab a').click(function() {
        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_BILLING;
        $('#shippingTab').removeClass('active');
        $('#billingTab').addClass('active');
        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
      });
      $('#shippingTab a').click(function() {
        COSTCO.CAddressBook.activeTab = CAddressBook.ADDRESS_TYPE_SHIPPING;
        $('#shippingTab').addClass('active');
        $('#billingTab').removeClass('active');
        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
      });
      $('a[href="#address"]').on('shown.bs.tab', function() {
        COSTCO.CAddressBook.populateAddressSection('addresses-list-box');
      });

      // TODO: Try to find more optimal solution!!!!
      // $(window).resize(function() {
      //   if ($('#address-book').length) {
      //     clearTimeout(CAddressBook.resizeTimer);
      //     CAddressBook.resizeTimer = setTimeout(function() {
      //       COSTCO.CAddressBook.resizedw();
      //     }, 100);
      //   }
      // });
      // TODO: Kurt says: Perhaps debouncing this function will work. Essentially
      // resize gets invoked constantly, this will stop function execution
      // until N seconds pass.
      //$(window).resize(COSTCO.util.debounce(
      //  COSTCO.CAddressBook.resizedw.bind(this), 300)).bind(this);
      
      $(window).resize(function() {
          if ($('#address-book').length) {
            clearTimeout(CAddressBook.resizeTimer);
            CAddressBook.resizeTimer = setTimeout(function() {
              COSTCO.CAddressBook.resizedw();
            }, 100);
          }
        });
      
    },

    /**
     * Callback on resize event. Refresh address and paging section.
     */
    resizedw: function() {
      this.populateAddressSection('addresses-list-box');
    },

    /**
     * Returns number of displayed addresses on page depending on screen size
     * @return entries per page
     */
    getEntriesPerPage() {
      if ($('#lg-visible-indicator').css('display') === 'none') {
        return CAddressBook.ENTRIES_PER_PAGE_NON_LG;
      } else {
        return CAddressBook.ENTRIES_PER_PAGE_LG;
      }
    },

    /**
     * Returns number of columns in address matrix
     * @return number of columns
     */
    getColumnNumber() {
      let columnNumber = 1;
      if ($('#xl-visible-indicator').css('display') != undefined && $('#xl-visible-indicator').css('display') != 'none') {
        columnNumber = 4;
      } else if ($('#lg-visible-indicator').css('display') != undefined && $('#lg-visible-indicator').css('display') != 'none') {
        columnNumber = 3;
      } else if ($('#md-visible-indicator').css('display') != undefined && $('#md-visible-indicator').css('display') != 'none') {
        columnNumber = 2;
      } else {
        columnNumber = 1;
      }
      return columnNumber;
    },

    /**
     * Sort addresses
     * @param addresses - addresses list to be sorted
     * @return sorted addresses list
     */
    sort: function(addresses) {
      let sortedAddressList = [];

      let sortType = $('option:selected', $('#sort_by')).val();
      if (sortType === CAddressBook.ADDRESS_SORT_MOST_RECENT) {
        sortedAddressList = addresses.sort(function(elem1, elem2) {
          // Default address need to be always first
          if (elem1.isPrimary) return -1;
          if (elem2.isPrimary) return 1;
          let id1 = parseInt(elem1.addressId);
          let id2 = parseInt(elem2.addressId);
          return ((id1 > id2) ? -1 : ((id1 < id2) ? 1 : 0));
        });
      }
      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_A_Z) {
        sortedAddressList = addresses.sort(function(elem1, elem2) {
          // Default address need to be always first
          if (elem1.isPrimary) return -1;
          if (elem2.isPrimary) return 1;
          let name1 = elem1.firstName.toLowerCase();
          let name2 = elem2.firstName.toLowerCase();
          return ((name1 < name2) ? -1 : ((name1 > name2) ? 1 : 0));
        });
      }
      if (sortType === CAddressBook.ADDRESS_SORT_FIRST_Z_A) {
        sortedAddressList = addresses.sort(function(elem1, elem2) {
          // Default address need to be always first
          if (elem1.isPrimary) return -1;
          if (elem2.isPrimary) return 1;
          let name1 = elem1.firstName.toLowerCase();
          let name2 = elem2.firstName.toLowerCase();
          return ((name1 > name2) ? -1 : ((name1 < name2) ? 1 : 0));
        });
      }
      if (sortType === CAddressBook.ADDRESS_SORT_LAST_A_Z) {
          sortedAddressList = addresses.sort(function(elem1, elem2) {
            // Default address need to be always first
            if (elem1.isPrimary) return -1;
            if (elem2.isPrimary) return 1;
            let name1 = elem1.lastName.toLowerCase();
            let name2 = elem2.lastName.toLowerCase();
            return ((name1 < name2) ? -1 : ((name1 > name2) ? 1 : 0));
          });
        }
        if (sortType === CAddressBook.ADDRESS_SORT_LAST_Z_A) {
          sortedAddressList = addresses.sort(function(elem1, elem2) {
            // Default address need to be always first
            if (elem1.isPrimary) return -1;
            if (elem2.isPrimary) return 1;
            let name1 = elem1.lastName.toLowerCase();
            let name2 = elem2.lastName.toLowerCase();
            return ((name1 > name2) ? -1 : ((name1 < name2) ? 1 : 0));
          });
        }
      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_A_Z) {
            sortedAddressList = addresses.sort(function(elem1, elem2) {
              // Default address need to be always first
              if (elem1.isPrimary) return -1;
              if (elem2.isPrimary) return 1;
              let name1 = elem1.company.toLowerCase();
              let name2 = elem2.company.toLowerCase();
              return ((name1 < name2) ? -1 : ((name1 > name2) ? 1 : 0));
            });
      }
      if (sortType === CAddressBook.ADDRESS_SORT_COMPANY_NAME_Z_A) {
          sortedAddressList = addresses.sort(function(elem1, elem2) {
            // Default address need to be always first
            if (elem1.isPrimary) return -1;
            if (elem2.isPrimary) return 1;
            let name1 = elem1.company.toLowerCase();
            let name2 = elem2.company.toLowerCase();
            return ((name1 > name2) ? -1 : ((name1 < name2) ? 1 : 0));
          });
        }
      
      return sortedAddressList;
    },

    /**
     * Populate address range which is currently displayed.
     * @param start - range bottom index
     * @param end - range up index
     * @param numberOfEntries - overall number of addresses of particular ttype( shipping or billing )
     */
    populateDisplayedEntriesRange: function(start, end, numberOfEntries) {
      $('.results > label').map(function() {
        $(this).text(addressBoxLabels.addressesRange);
        $(this).text($(this).text().replace('{0}', start));
        $(this).text($(this).text().replace('{1}', end));
        $(this).text($(this).text().replace('{2}', numberOfEntries));
      });
    },


    /**
     * Get addresses for particular page
     * @param addresses - address list
     * @param pageNum - number of page to be displayed
     * @return address list for particular page
     */
    getEntriesForPage: function(addresses, pageNum) {
      let addressesPerPage = this.getEntriesPerPage();
      let totalPagesNum = (addresses.length % addressesPerPage == 0) ? parseInt(addresses.length / addressesPerPage) : parseInt(addresses.length / addressesPerPage) + 1;
      if(pageNum > totalPagesNum) {
    	  pageNum = totalPagesNum;
    	  this.setCurrentPageNumber(pageNum);
      }
      let startIndex = (pageNum - 1) * addressesPerPage;
      let endIndex = (pageNum * addressesPerPage < addresses.length) ? pageNum * addressesPerPage - 1 : addresses.length - 1;
      let resultArr = [];
      $.each(addresses, function(index, value) {
        if (startIndex <= index && index <= endIndex) {
          resultArr.push(value);
        }
      });
      this.populateDisplayedEntriesRange(startIndex + 1, endIndex + 1, addresses.length);
      return resultArr;
    },

    /**
     * Dynamically populate addresses.
     * @param  - id of block which will contain created content
     * @param newAddressBtnId - id of section which holds new address button.
     * @pageNum - page number for display
     */
    populateAddressSection: function(blockId, pageNum) {
      if (typeof pageNum === 'undefined') {
        pageNum = this.getCurrentPageNumber();
      } else {
        this.setCurrentPageNumber(pageNum);
      }

      let addresses = this.filterAddressesByType(this.activeTab);
      if (addresses.length > 0) {
        $('#sort-section').show();
        addresses = this.sort(addresses);
      } else {
        $('#sort-section').hide();
      }

      let addressesForDisplay = this.getEntriesForPage(addresses, pageNum);

      this.createAddressesMatrix(blockId, addressesForDisplay);
      this.addjustCells('.resizable');
      this.populatePagingSection('search-results', addresses.length);
      // TODO Kurt says: This is slightly disorienting on desktop resolution
      if (COSTCO.util.getScreenType() != 'DESKTOP') {
        this.backToTop();
      }
    },

    /**
     * [description]
     * @param  {[type]} newAddressBtnId [description]
     * @return {[type]}                 [description]
     */
    createNewAddressButton: function(newAddressBtnId) {
      $('#' + newAddressBtnId).html('');
      let btnTemplate = COSTCO.util.tmpl('add_new_address_btn_tmpl', {});
      btnTemplate = $(btnTemplate);
      $('#' + newAddressBtnId).append(btnTemplate);
    },

    /**
     * Create address matrix
     * @param blockId - id of block which will contain created content
     * @addressesForDisplay - array of addresses which will be displayed
     */
    createAddressesMatrix: function(blockId, addressesForDisplay) {
      let columnNumber = this.getColumnNumber();
      $('#' + blockId).html('');
      $.each(addressesForDisplay, function(index, value) {
        let template = (value.isPrimary) ? COSTCO.util.tmpl('address_box_default', value) : COSTCO.util.tmpl('address_box', value);
        template = $(template);
        template.find('#address-info-container').addClass('resizable-' + parseInt((index + 1) / columnNumber));
        // Adjust checkbox style and label text
        let checkboxElem = template.find('#setDefault_' + value.addressIndex);
        COSTCO.CAddressBook.setAHrefCellLook($(checkboxElem), !value.isPrimary);

        $('#' + blockId).append(template);
      });
    },
    
    createDefaultShippingAddressErrorDiv: function(errorDivId) {
      let defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING)[0];
      let errorDivTemplate = COSTCO.util.tmpl('tmpl_default_address_error', defaultShippingAddress);
      $('#' + errorDivId).append(errorDivTemplate);
      $('#' + errorDivId).show();
    },

    /**
     * Populate paging section
     * @param blockId - id of block which will contain created content
     */
    populatePagingSection: function(blockId, addressListSize) {
      let addressesPerPage = this.getEntriesPerPage();
      let currentPage = this.getCurrentPageNumber();
      if (addressListSize > addressesPerPage) {
        $('#' + blockId).show();
        let elem = $('#' + blockId + ' div > ul');
        elem.html('');
        elem.append('<li class="back"><a id="previous-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-left"></i></a></li>');

        let pagesNum = (addressListSize % addressesPerPage == 0) ? parseInt(addressListSize / addressesPerPage) : parseInt(addressListSize / addressesPerPage) + 1;
        let pagesArray = [];
        for (i = 1; i <= pagesNum; i++) {
          pagesArray.push({
            'containerId': '\'addresses-list-box\'',
            'pageNum': i,
          });
        }
        let pageIndex = currentPage - 1;
        $.each(pagesArray, function(index, value) {
          let template = COSTCO.util.tmpl('address_pagination_box', value);
          template = $(template);
          let pageBtn = template.find('.btn');
          if (index == pageIndex) {
            pageBtn.addClass('btn-primary');
          } else {
            pageBtn.removeClass('btn-primary');
          }
          elem.append(template);
        });
        elem.append('<li class="forward"><a id="next-page" class="body-copy-link" href="javascript:void(0)"><i class="co-arrow-right"></i></a></li>');
        if (currentPage == 1 || pagesNum == 1) {
          $('#previous-page').parent().hide();
        } else {
          $('#previous-page').parent().show();
          $('#previous-page').unbind().on('click', function() {
            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage - 1);
          });
        }
        if (currentPage == pagesNum || pagesNum == 1) {
          $('#next-page').parent().hide();
        } else {
          $('#next-page').parent().show();
          $('#next-page').unbind().on('click', function() {
            COSTCO.CAddressBook.populateAddressSection('addresses-list-box', currentPage + 1);
          });
        }
        //	    		$('.results > label').map(function() {
        //	    			$(this).show();
        //	    		});
      } else {
        $('#' + blockId).hide();
        //	    		$('.results > label').map(function() {
        //	    			$(this).hide();
        //	    		});
      }
    },

    /**
     * Returns active address type
     * @return address type string: Shipping or Billing
     */
    getActiveAddressType: function() {
      let addressType = ($('#shippingTab').hasClass('active')) ?
        CAddressBook.ADDRESS_TYPE_SHIPPING :
        CAddressBook.ADDRESS_TYPE_BILLING;
      return addressType;
    },

    setActiveAddressType: function() {
      if (this.activeTab === CAddressBook.ADDRESS_TYPE_SHIPPING) {
        $('#billingTab').removeClass('active');
        $('#shippingTab').addClass('active');
      } else {
        $('#shippingTab').removeClass('active');
        $('#billingTab').addClass('active');
      }
    },

    getCurrentPageNumber: function() {
      let pageNumber = ($('#shippingTab').hasClass('active')) ?
        this.currentShippingPage :
        this.currentBillingPage;
      return pageNumber;
    },

    setCurrentPageNumber: function(pageNum) {
      if ($('#shippingTab').hasClass('active')) {
        this.currentShippingPage = pageNum;
      } else {
        this.currentBillingPage = pageNum;
      }
    },

    /**
     * Filters addresses by type: Shipping or Billing
     * @param address type
     * @return address list of particular type
     */
    filterAddressesByType: function(addressType) {
      let result = [];
      $.each(COSTCO.util.addresses, function(index, value) {
        if (value.addressType.trim() === addressType) {
        	let addressObj = {};
        	addressObj.addressIndex = index;
        	addressObj.defaultAddressType = addressType;
        	addressObj.addressId = value.id;
        	addressObj.isPrimary = (value.isPrimary === '1');
        	addressObj.company = value.company;
        	addressObj.firstName = value.first;
        	addressObj.lastName = value.last;
        	addressObj.addressLine0 = value.line1;
        	addressObj.addressLine1 = value.line2;
        	addressObj.city = value.city;
        	addressObj.state = value.state;
        	addressObj.postalCode = value.zip;
        	addressObj.phoneNo = (value.phone) ? value.phone.substring(0,3) + '-' + value.phone.substring(3,6) + '-' + value.phone.substring(6) : "";
        	addressObj.email = value.email;
        	addressObj.addressField1 = '';
        	addressObj.userAddressType = value.userAddressType;
        	addressObj.showAddressType = value.showAddressType;
        	addressObj.showAddressTypeEdit = value.showAddressTypeEdit;
        	
        	result.push(addressObj);
        }
      });
      return result;
    },

    /**
     * Adds new address
     * @param setDefault - sets newly added address as default one
     */
    addNewAddress: function(setDefault) {
      let addressType = ($('#shippingTab').hasClass('active')) ? 'S' : 'B';
      let addressOptions = {};
      if (setDefault != undefined) {
        addressOptions.setAsDefaultAddress = setDefault;
      }
      this.createNewAddress(addressType, addressOptions);
    },

    /**
     * Prepares data for add address modal display
     * @param {String} addressType	Type of address to create ('S' - shipping, 'B' - billing)
     * @param addressOptions - address options
     */
    createNewAddress: function(addressType, addressOptions) {
      if (addressOptions == undefined) {
        addressOptions = {};
      }

      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_ADD;
      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
      if (COSTCO.util.isBusinessDelivery() && addressType === 'S' && !COSTCO.util.isNdEnabled()){
    	  this.termsAndCond(addressType, undefined, 'add', addressOptions);
      }else{
    	  this.openAddressAddModal(addressType, undefined, 'add', addressOptions);
      }
    },

    /**
     * Opens add/edit address modal
     * If it is edit modal, jQuery validator is triggered immediately
     * @param {String} addressType			Type of address to create ('S' - shipping, 'B' - billing)
     * @param {Object} addressObj			If mode 'edit', address object to prepopulate input fields in modal
     * @param {String} mode					Mode of address modal ('add' - add new address, 'edit' - edit existing address)
     * @param {String} addressOptions		Various options for address add/edit
     */
    openAddressAddModal: function(addressType, addressObj, mode, addressOptions) {
      if (addressOptions.tmplFooterText) {
        var footerText = COSTCO.util.tmpl(addressOptions.tmplFooterText, {});
      }

      var openAddress = function(error){
        let htmlBody = COSTCO.CAddressForm.createHtml(addressType, addressObj, mode, undefined, undefined, undefined, error);
    	  let key = "footerText";
    	  let isEditDefaultShippingAddress = false;
        if(mode == "edit") {
          if (addressOptions.setAsDefaultAddress) {
            key = "footerText2";
            isEditDefaultShippingAddress = true;
          }

    	  	COSTCO.CAddressForm.validate(addressType, htmlBody, isEditDefaultShippingAddress);
        }
    	  
        COSTCO.CAddress.baseModal(addressType, mode, {
          body: htmlBody,
          [key]: footerText,
          primary_event: function() {
            if (COSTCO.CAddressForm.validate(addressType)) {
            	addressOptions.addressBookReinit = true;
            	COSTCO.CAddressForm.submit(addressType, false, addressOptions);
            }
          },
          onshown: function(){
        	  
              if (addressOptions.setAsDefaultAddress) {
                  $('#set-default').val('true');
                  $('#set-default').attr('checked', true);
                } else {
                  $('#set-default').val('false');
                  $('#set-default').attr('checked', false);
                }
              
              if($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
            	  let formId = $('#address-modal-modal');
              	  let addressField = '#address1Id';
            	  COSTCO.dialog.sameAddressValidation(formId, addressField);
              }
              COSTCO.CAddressForm.updateAddressModal();
          }
        });
      };

      openAddress(undefined);

      $('body').unbind('costco.address.error').bind('costco.address.error', function(event, error) {
        openAddress(error);
      });

      $('.country-select').on('change', function() {
        let stateProvList = COSTCO.CAddressForm.addressVal;
        let country = $('.country-select').val();
        let stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType, {country: country});
        $('.stateprov-select').empty().append(stateOptions);
        $('#postalId').val('');
        $('#cityId').val('');
        
        if ($('.country-select').val() === 'US') {
          $('[name=postal]').unmask().mask('00000-0000');
          COSTCO.CAddressBook.updateCountryLabels(country);
	    } else if ($('.country-select').val() === 'CA') {
	      $('[name=postal]').unmask().mask('S0S 0S0');
	      COSTCO.CAddressBook.updateCountryLabels(country);
	   	}
      });

      if (mode === 'add' && $('#address-same-as-ship').length > 0 && this.getActiveAddressType() === CAddressBook.ADDRESS_TYPE_BILLING) {
    	$('#address-same-as-ship').removeClass('hide');
      }

      if ($('#rx-email-address').length > 0) {
        $('#emailId').val($('#rx-email-address').html().trim());
      } 
      let legendTypeName='legendBillingText';
      if(addressType == 'S'){
          	 legendTypeName = 'legendShippingText';
          }
      $('#address-modal-modal fieldset legend').text($("input[name="+legendTypeName +"]:hidden").val());
    },
    
	updateCountryLabels: function(country){
		let $form = COSTCO.CAddressForm.getForm();
		let $postal = $form.find('label[for="postalId"]');
		let $state = $form.find('label[for="stateId"]');
		if(country == 'US'){
			$postal.html(messages.RWD_US_ZIP_LABEL);
			$state.html(messages.RWD_US_STATE_LABEL);
		} else {
			$postal.html(messages.RWD_CA_ZIP_LABEL);
			$state.html(messages.RWD_CA_STATE_LABEL);
		}
	},

    /**
     * Prepares data for edit address modal display
     * @param {String} addressType	Type of address to edit ('S' - shipping, 'B' - billing)
     * @param {Object} obj 					Address object to be edited
     */
    editAddress: function(obj) {
      let addressType = ($('#shippingTab').hasClass('active')) ? 'S' : 'B';
      let addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
      var validateAddressTypeModal=[];
      data = addressJson;
      let addressOptions = {};
      addressOptions.url = CAddressBook.url.MANAGE_ADDRESS_UPDATE;
      addressOptions.tmplFooterText = 'tmpl_rx_add_edit_address_footer';
      if(data.userAddressType!='U'){
			validateAddressTypeModal[3] = data.userAddressType;
		}
      if(addressJson.isPrimary && addressJson.isPrimary ==='1'){
    	  addressOptions.setAsDefaultAddress = addressJson.isPrimary;
        addressOptions.tmplFooterText = 'tmpl_add_edit_address_footer';
      }
      if(addressType === 'B') {
    	addressOptions.tmplFooterText = 'tmpl_add_edit_billing_address_footer';
      }
      addressOptions.validateParams=validateAddressTypeModal;
      //National delivery UX change to remove Terms and Condition Modal in Address book for BD US
      if (COSTCO.util.isBusinessDelivery() && addressType === 'S'){
    	  if(COSTCO.util.isNdEnabled()){
    		  COSTCO.CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
    	  }else{
    		  this.termsAndCond(addressType, data, 'edit', addressOptions);
    	  }
      }else{
    	  CAddressBook.openEditAddressModal(addressType, data, addressOptions);
      }
    },

    openEditAddressModal: function(addressType, data, addressOptions) {
      if (data.addressType === 'S' && data.isPrimary === '1') {
        COSTCO.dialog.createExtDialogBox({
          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
          body: $('#tmpl_default_address_info_dialog').html(),
          primary: messages.JS_DIALOG_ACCEPT,
          primary_event: function() {
            CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
            $('#costcoModal').modal('hide');
          },
          secondary: messages.JS_DIALOG_CANCEL,
        });
      } else {
        CAddressBook.openAddressAddModal(addressType, data, 'edit', addressOptions);
      }
    },

    /**
     * Sets address to be default
     * @param {String} addressId 		Address id to be set as default
     */
    setDefault: function(addressId, onDoneCallback) {
    	
    	if(typeof onDoneCallback === 'undefined') {
    		onDoneCallback = function() {
            	COSTCO.CAddressBook.init();
            }
    	}
      COSTCO.Checkout.ajax_update_state({
        url: CAddressBook.url.MANAGE_ADDRESS_SET_DEFAULT,
        method: 'POST',
        dataType: 'json',
        data: {
          authToken: COSTCO.Checkout.getAuthToken(),
          mode: 'SET_DEFAULT',
          formdata: encodeURIComponent(JSON.stringify({
            'id': addressId,
          })),
        },
        done: onDoneCallback
      });
    },

    /**
     * Removes address
     * @param {String} addressId - Address id to be removed
     */
    remove: function(addressId) {
      COSTCO.Checkout.ajax_update_state({
        url: CAddressBook.url.MANAGE_ADDRESS_REMOVE,
        method: 'POST',
        dataType: 'json',
        data: {
          authToken: COSTCO.Checkout.getAuthToken(),
          mode: 'DELETE',
          formdata: encodeURIComponent(JSON.stringify({
            'id': addressId,
          })),
        },
        done: function() {
        	COSTCO.CAddressBook.init();
        }
      });
    },

    /**
     * Opens default address confirmation modal and executes appropriate action
     * @param addressId - address id
     * @param element - html element which is going to be updated
     */
    setDefaultAddress: function(addressId, element) {
      if ($('#shippingTab').hasClass('active') &&
        CAddressBook.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING).length > 0 && !COSTCO.util.isBusinessDelivery()) {
        COSTCO.dialog.createExtDialogBox({
          title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
          body: $('#tmpl_default_address_info_dialog').html(),
          primary: messages.JS_DIALOG_ACCEPT,
          primary_event: function() {
            CAddressBook.setDefault(addressId);
            $('#costcoModal').modal('hide');
          },
          secondary: messages.JS_DIALOG_CANCEL,
        });
      } else {
        CAddressBook.setDefault(addressId);
      }
    },

    /**
     * Opens remove confirmation modal
     * @param addressId - id of address for removal
     */
    removeAddress: function(addressId) {
      COSTCO.dialog.createExtDialogBox({
        title: addressBoxLabels.removeAddressTitle,
        body: $('#tmpl_remove_address_info_dialog').html(),
        primary: addressBoxLabels.removeLink,
        primary_event: function() {
          CAddressBook.remove(addressId);
          $('#costcoModal').modal('hide');
        },
        secondary: messages.JS_DIALOG_CANCEL,
        onshown: function(){
          COSTCO.CAddressForm.updateAddressModal();
        }
      });
    },

    setAHrefCellLook: function(element, toDefault) {
      let parentDiv = element.parent().closest('div');
      let aElem;
      if (toDefault) {
        aElem = parentDiv.find('a').attr('id', $(element).attr('id'));
      } else {
        aElem = parentDiv.find('p');
      }

      let linkText = ($('#shippingTab').hasClass('active')) ?
        ((toDefault) ? addressBoxLabels.setShippingAddress :
          addressBoxLabels.defaultShippingAddress) :
        ((toDefault) ? addressBoxLabels.setBillingAddress :
          addressBoxLabels.defaultBillingAddress);
      aElem.html(linkText);
    },

    /**
     * Returns default address of particular address type.
     * @return default address
     */
    getDefaultAddress: function(addressType) {
      let defaultAddress = [];
      $.each(CAddressBook.filterAddressesByType(addressType), function(index, value) {
        if (value.isPrimary) {
          defaultAddress.push(value);
        }
      });
      return defaultAddress;
    },

    /**
     * Function which populates new billing address fields with
     * default shipping address data.
     * @param input
     */
    handleBillingSameAsShipping: function(input) {
      if (input.checked) {
        let defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
        if (defaultShippingAddress.length > 0) {
          COSTCO.util.getAddressBatchPage('S', 'FIRSTNAME', 'ASC', '1', '96', function(data) {
            data = COSTCO.CAddress.getAddressJson(defaultShippingAddress[0].addressId)[0];

            if (data != null) {
              delete data['id'];
              delete data['nickname'];
             // delete data['isPrimary'];
              COSTCO.CAddressForm.populateAddressModal($(input.form), data, 'modal');
            }
          });
        }
      } else {
        COSTCO.CAddressForm.populateAddressModal($(input.form), '', 'modal');
      }
    },

    backToTop: function() {
      document.body.scrollTop = 0; // For Chrome, Safari and Opera
      document.documentElement.scrollTop = 0; // For IE and Firefox
    },
    /**
	 * This function is used for showing the  and condition in cased of BD
	 * shipping address
	 */
    termsAndCond : function(addressType, addressObj, mode, addressOptions){
    	
	    COSTCO.dialog.createExtDialogBox({
	        title: messages.BD_DELIVERY_ADDRESS_TERMS,
	        body: $('#tmpl_delivery_warning').html(),
	        primary: messages.JS_DIALOG_AGREE,
	        primary_event: function() {
	    		COSTCO.CAddressBook.openAddressAddModal(addressType, addressObj, mode, addressOptions);
	        },
	        secondary: messages.JS_DIALOG_CANCEL,
	    });

    },
    /**
     * This method shows the Address type popup for change link in Address Book
     * Calls the 'AjaxManageAddressCmd' to save user selected Address type to DB
   */
   addUserSelectionFromAddressBook: function(addressId){
 		COSTCO.dialog.createExtDialogBox({
 			title : messages.SET_ADDRESS_TYPE,
 			body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
 			primary : messages.SET_ADDRESS_TYPE,
 			popover : true,
 		    primary_event: function(){
 		    	if(document.querySelector('input[name="addrtype"]:checked') == null){
		    		$('.addresstype-setup-notification').removeClass("hidden");
		    		$('.addresstype-setup-notification').find("div").html(messages.ERR_ADDRESS_TYPE_NOT_SELECTED);
		    	}else{
	 		        userAddressType = document.querySelector('input[name="addrtype"]:checked').value;
	 		      	onDoneCallback = function() {COSTCO.CAddressBook.init();}
	 		        COSTCO.Checkout.ajax_update_state({
	 		          url: CAddressBook.url.MANAGE_ADDRESSTYPE_UPDATE,
	 		          method: 'POST',
	 		          dataType: 'json',
	 		          data: {
	 		            authToken: COSTCO.Checkout.getAuthToken(),
	 		            mode: 'SET_ADDRESSTYPE',
	 		            formdata: encodeURIComponent(JSON.stringify({
	 		              'id': addressId,'userAddressType': userAddressType,
	 		            })),
	 		          },
	 		          done: onDoneCallback
	 		        });
	 		       COSTCO.dialog.close();
		    	}
 		    }
 		});	
 		$('.close').addClass("hidden");
   },
   
   addressbookTabAriaExpandedSwitch: function(){
	   $('.costco-tabs-alternate .table-cell .active').find('a').attr('aria-expanded', 'true');
	   
	   $('.costco-tabs-alternate .table-cell a').on('click', function(e) {
		   if($('#shippingTab').attr('class').includes('active')){
			   $('#shippingTab').find('a').attr('aria-selected', 'true');
			   $('#billingTab').find('a').attr('aria-selected', 'false');
		   } else {
			   $('#shippingTab').find('a').attr('aria-selected', 'false');
			   $('#billingTab').find('a').attr('aria-selected', 'true');
		   }
       });	   
   },
    //Checks to see if the default shipping address has a valid phone number and email address
    //Prompts the user to verify default shipping address if there is a problem with either 
    validateShippingAddressPhoneNumber: function(){
      var PHONE_NUMBER_REGEX = new RegExp("^\\(?([2-9]{1}[0-9]{2})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})$");
      let defaultShippingAddress = this.getDefaultAddress(CAddressBook.ADDRESS_TYPE_SHIPPING);
      if (defaultShippingAddress.length > 0) {
        var hasValidPhoneNumber = PHONE_NUMBER_REGEX.test(defaultShippingAddress[0].phoneNo.substring(0,12));
        var hasEmail = Boolean(defaultShippingAddress[0].email);
        if (!hasValidPhoneNumber || !hasEmail) {
          COSTCO.CAddressBook.createDefaultShippingAddressErrorDiv('invalidAddressError');
        }
      }
    },
  
    analytics: function() {
      let addressBookPage = document.getElementById("address-book");
      if (typeof(addressBookPage) != 'undefined' && addressBookPage != null)
      {
        window.digitalData = window.digitalData || {};
        digitalData.pageName = "My Account | Address Book";
        digitalData.pageType = "My Account";
      }
    }
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.CAddressBook = CAddressBook;
  return CAddressBook;
});




// WEBPACK FOOTER //
// ./js/address/addressBook.js